// Lixeira pequena no título de uma seção da lista (AC-235) ou de "Tarefas recorrentes"
// (AC-236): pergunta antes, com o mesmo pop-up de excluir uma tarefa.
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ConfirmDialog } from './EditTaskDialog';
import { Icon } from './Icon';

interface Props {
  /** nome do botão para leitores de tela e dica ao passar o mouse */
  label: string;
  title: string;
  body: string;
  disabled?: boolean;
  onConfirm(): unknown;
}

export function SectionTrash({ label, title, body, disabled, onConfirm }: Props) {
  const { t } = useTranslation();
  const [asking, setAsking] = useState(false);
  return (
    <>
      <button type="button" className="icon-btn icon-btn--sm section__trash" aria-label={label} title={label} disabled={disabled} onClick={() => setAsking(true)}>
        <Icon name="trash" size={13} />
      </button>
      {asking && (
        <ConfirmDialog
          title={title}
          body={body}
          confirmLabel={t('task.delete')}
          danger
          onCancel={() => setAsking(false)}
          onConfirm={async () => {
            setAsking(false);
            await onConfirm();
          }}
        />
      )}
    </>
  );
}
